import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { AlertCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[60vh] flex items-center justify-center pt-10 pb-8 px-4 overflow-hidden" data-id="element-261">
      {/* Background elements */}
      <div className="absolute inset-0 bg-neutral-950 z-0" data-id="element-262" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,107,0,0.1)_0%,transparent_60%)] z-0" data-id="element-263" />

      <div className="container mx-auto max-w-4xl relative z-10 text-center" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-265">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-500/10 text-red-500 font-medium mb-5 border border-red-500/20 text-sm" data-id="element-266">
            <AlertCircle size={18} data-id="element-267" />
            <span data-id="element-268">Guía de Primeros Auxilios Felinos</span>
          </div>

          <h1 className="text-4xl md:text-8xl font-display text-white mb-4 leading-[0.9]" data-id="element-269">
            A las 3 de la mañana,
            <br data-id="element-270" />
            <span className="text-brand" data-id="element-271">Google no es un veterinario.</span>
          </h1>

          <h2 className="text-lg md:text-2xl text-neutral-300 font-medium mb-5 max-w-3xl mx-auto leading-relaxed" data-id="element-272">
            Mantené a tu gato a salvo con el Protocolo de 60 Segundos: La guía
            de primeros auxilios que todo dueño de michi en Argentina debe tener
            antes de una emergencia.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-neutral-900/80 border border-neutral-800 p-4 md:p-6 rounded-2xl text-left mb-6 max-w-3xl mx-auto backdrop-blur-sm" data-id="element-273">
          <p className="text-base text-neutral-300 leading-relaxed mb-3" data-id="element-274">
            Estás durmiendo y escuchás un ruido extraño en el living. Tu gato
            está de costado, respirando con la boca abierta y las pupilas
            dilatadas. El pánico te hiela la sangre. Agarrás el celular, buscás
            en Google y encontrás 2 millones de resultados contradictorios
            mientras los minutos —esos que salvan vidas— se te escapan de las
            manos.
          </p>
          <p className="text-base text-neutral-300 leading-relaxed font-medium text-white" data-id="element-275">
            No saber qué hacer en ese momento es una de las sensaciones más
            horribles que puede vivir un dueño. Pero hoy, podés elegir no volver
            a sentir esa impotencia nunca más.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-276">
          <Button href="#pricing" size="xl" className="w-full md:w-auto" data-id="element-277">
            ¡QUIERO EL PROTOCOLO DE EMERGENCIA AHORA!
          </Button>
          <p className="mt-3 text-xs text-neutral-500" data-id="element-278">
            Acceso inmediato • Pago seguro • Edición Argentina
          </p>
        </motion.div>
      </div>
    </section>;
}